import React, { useState } from "react";
import { FaStar } from "react-icons/fa";

const Rating = ({ rating, setRating }) => {
  const [hoverRating, setHoverRating] = useState(0);

  const labels = ["", "Poor", "Fair", "Good", "Great", "Excellent"];

  const colors = {
    1: "#ef4444", // red
    2: "#f97316", // orange
    3: "#eab308", // yellow
    4: "#22c55e", // green
    5: "#10b981", // emerald
  };

  const activeRating = hoverRating || rating;
  const activeColor = colors[activeRating] || "#d1d5db";

  return (
    <div className="flex flex-col items-center gap-2">
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            onClick={() => setRating(star)}
            onMouseEnter={() => setHoverRating(star)}
            onMouseLeave={() => setHoverRating(0)}
            className="p-1 transition-transform duration-150 hover:scale-110 active:scale-95 focus:outline-none"
          >
            <FaStar
              size={36}
              className="transition-colors duration-200"
              style={{
                color: star <= activeRating ? activeColor : "#e5e7eb",
              }}
            />
          </button>
        ))}
      </div>

      <div
        className="h-6 text-sm font-medium transition-all duration-200"
        style={{ color: activeRating ? activeColor : "#9ca3af" }}
      >
        {activeRating ? labels[activeRating] : "Tap to rate"}
      </div>
    </div>
  );
};

export default Rating;
